/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import product from "../../../../models/product";
// CSS
import "../../../../css/SelectOptionBtn.css";
import { order } from "../../../../models";

let $ = window.$;

class Lv1SelectOptionBtn extends React.Component {
  getClass(matching) {
    const style =
      (matching && "select blockBtn border-grey smaller") ||
      "blockBtn border-grey smaller";
    return style;
  }
  handleClick = async e => {
    const {
      value,
      selectLv1Option,
      changeLv1SelectOptionDefault,
      clickLv1OptionToChangeLv2,
      clickLv2OptionToChangeLv3,
      resetQuantity
    } = this.props;

    $(".outOfStockForm_wrap")
      .finish()
      .fadeOut();

    await resetQuantity();
    await selectLv1Option(value); //找出被點擊的Lv1Btn的索引，並且更新Lv2List
    await changeLv1SelectOptionDefault(value);
    await clickLv1OptionToChangeLv2();
    await clickLv2OptionToChangeLv3();
  };

  handleMouseOver = () => {
    const lv1Name = this.props.name;
    this.props.mouseOverLv1Name(lv1Name);
  };

  handleMouseLeave = () => {
    this.props.mouseLeaveLv1Name();
  };

  render() {
    const { value, lv1Default } = this.props;
    const item = this.props.default;
    return (
      <a
        className={this.getClass(value === lv1Default)}
        onClick={e => this.handleClick(e)}
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
        style={{
          backgroundImage: `url("${item.thumbnail}")`,
          minWidth: "auto",
          minHeight: "auto",
          width: "2.5rem",
          height: "2.5rem",
          backgroundSize: "1.8rem",
          padding: "0",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundColor: "white"
        }}
      >
        <span />
      </a>
    );
  }
}

const mapStateToProps = state => {
  return {
    lv1Default: state.product.lv1Default,
    relations: state.product.ui.options.relations
  };
};
const mapDispatchToProps = () => {
  return {
    resetQuantity: () => order.actions.resetQuantity(),
    selectLv1Option: index => product.actions.selectLv1Option(index),
    changeLv1SelectOptionDefault: data =>
      product.actions.changeLv1SelectOptionDefault(data),
    clickLv1OptionToChangeLv2: () =>
      product.actions.clickLv1OptionToChangeLv2(),
    clickLv2OptionToChangeLv3: () => product.actions.clickLv2OptionToChangeLv3()
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Lv1SelectOptionBtn);
